// ToggleButton.jsx
import React from 'react';

const ToggleButton = ({ 
  isDisabled = false, 
  onToggle, 
  size = 'md',
  disabled = false,
  className = '',
  activeText = 'Disable',
  inactiveText = 'Enable',
  activeColor = 'blue',
  inactiveColor = 'gray',
  showLabel = true,
  labelPosition = 'right'
}) => {
  
  // Size variants
  const sizeClasses = {
    sm: 'w-8 h-4',
    md: 'w-11 h-6',
    lg: 'w-14 h-7'
  };
  
  const dotSizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  const dotTranslateClasses = {
    sm: 'translate-x-4',
    md: 'translate-x-5',
    lg: 'translate-x-7'
  };

  // Color variants
  const colorClasses = {
    blue: {
      active: 'bg-blue-600',
      inactive: 'bg-gray-300',
      hover: 'hover:bg-blue-700'
    },
    green: {
      active: 'bg-green-600',
      inactive: 'bg-gray-300',
      hover: 'hover:bg-green-700'
    },
    red: {
      active: 'bg-red-600',
      inactive: 'bg-gray-300',
      hover: 'hover:bg-red-700'
    },
    gray: {
      active: 'bg-gray-600',
      inactive: 'bg-gray-300',
      hover: 'hover:bg-gray-700'
    }
  };

  const color = colorClasses[activeColor] || colorClasses.blue;
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const dotSize = dotSizeClasses[size] || dotSizeClasses.md;
  const dotTranslate = dotTranslateClasses[size] || dotTranslateClasses.md;

  const handleToggle = (e) => {
    if (!disabled && onToggle) {
      onToggle(e);
    }
  };

  const ToggleComponent = (
    <button
      type="button"
      className={`
        relative inline-flex items-center
        ${sizeClass}
        ${isDisabled ? color.active : color.inactive}
        ${!disabled ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}
        rounded-full transition-colors duration-300 ease-in-out
        ${!disabled && color.hover}
        ${className}
      `}
      onClick={handleToggle}
      disabled={disabled}
      role="switch"
      aria-checked={isDisabled}
      aria-label={isDisabled ? activeText : inactiveText}
    >
      <span
        className={`
          ${dotSize}
          bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out
          ${isDisabled ? dotTranslate : 'translate-x-0.5'}
        `}
      />
    </button>
  );

  // If no label, return just the toggle
  if (!showLabel) {
    return ToggleComponent;
  }

  // With label
  return (
    <div className="flex items-center gap-2">
      {labelPosition === 'left' && (
        <span className="text-sm font-medium text-gray-700">
          {isDisabled ? activeText : inactiveText}
        </span>
      )}
      
      {ToggleComponent}
      
      {/* {labelPosition === 'right' && (
        <span className="text-sm font-medium text-gray-700">
          {isDisabled ? activeText : inactiveText}
        </span>
      )} */}
    </div>
  );
};

export default ToggleButton;